export const costs = [
  'You learn fiber, cabling and telecom networks from scattered manuals, vendor-specific courses and forum posts that never show how the whole network fits together',
  "You don't fully understand OTDR traces, loss budgets, PON splits or microwave link budgets, so every fiber cut, low-light alarm and night call-out feels stressful",
  'Fiber, structured cabling, FTTH, radio links, cell sites and network operations are never explained in one clear, vendor-neutral place',
  'You lack the time to build a complete, coherent understanding of the network from the splice tray to the tower and the NOC',
];
